//#region src/components/layouts/JustifiedGallery/constants.ts
var e = 1.77777, t = {
	sm: 185,
	md: 215,
	lg: 215,
	xl: 245
};
//#endregion
export { e as DEFAULT_ASPECT_RATIO, t as JUSTIFIED_GALLERY_DEFAULT_HEIGHTS };
